import { useSelector } from 'react-redux';
import { Languages } from '../../utils/LanguageData';
import { AppState } from '@/store/Store';
import useLanguageChange from '@/utils/useLanguageChange';
// import earthFlagWihte from '/src/assets/images/flag/icon-earth-w.svg';
// import earthFlagBlack from '/src/assets/images/flag/icon-earth-b.svg';
import { EarthIcon } from 'lucide-react';

export default function LanguageAction() {
  const customizer = useSelector((state: AppState) => state.customizer)
  const lang = Languages.filter((lang) => lang.value !== customizer.isLanguage)[0];
  const langChange = useLanguageChange()

  const handleChageLanguage = ( value: string ) => {
   langChange(value);
  }

  return (
      <div 
        id='lang-container'
        style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer" }}
        onClick={() => handleChageLanguage(lang.value)}
      >
        <EarthIcon strokeWidth={1}/>
        <span className='text-[0.8rem]'>
          {lang?.name}
        </span>
      </div>
  )
}

